export default __webpack_public_path__ + "./images/schweizer5-logo.svg";